import { scroll } from "motion";

const HomeBanner = parent => {
  const scrollParallaxEl = parent.querySelector('.scroll-parallax');
  const scrollImageContainer = parent.querySelector('.scroll-image-container');

  if (scrollParallaxEl) {
    scroll(
      (progress) => {
        parent.style.setProperty("--scroll-percent", progress.y.progress);

        if (progress.y.progress >= 1) {
          scrollImageContainer.classList.add("!rounded-none");
        } else {
          scrollImageContainer.classList.remove("!rounded-none");
        }
      },
      {
        target: scrollParallaxEl,
        offset: [`-${scrollParallaxEl.querySelector('.sticky-element').offsetHeight * 2}px end`, "end end"],
      },
    );
  }
}

export default HomeBanner;